(function () {
    angular.module('components.tiles', [
        'utility',
        //'foundation.core',
        //'foundation.mediaquery',
        'ngAnimate'
    ])
        .directive('genericTile', genericTile)
        .directive('customTile', customTile)
        //.controller('accordionTilesController', accordionTilesController)
        //.directive('accordionTiles', accordionTiles)
        //.directive('accordionTile', accordionTile)
        .directive('windowTile', windowTile)
        //.animation('.window', windowAnimation);
        .component('assemblyTile', {
            controller: assemblyTileController
        })

    /**
     * @ngdoc directive
     * @module components.tiles
     * @name components.tiles:genericTile
     * @scope
     * @restrict E
     * @description
     * Tile that animates in displays a chunk of text and reveals more when it is hovered over. The position of the expanding region can be changed by adding the class "bottom" or "top." Content that is visible initially should go inside the "above-fold" tag, while content that appears on hover should go in the "below-fold" tag.
     * @param {string=} backgroundImage Places an image behind the tile.
     * @example
        <example module="dataExample">
            <file name="index.html">
                <div ng-controller="exampleController">
                    <h3>Tile has no class</h3>
                    <generic-tile background-image="//lorempixel.com/400/400/animals">
                        <above-fold>
                            <h5 style="color: red">No Class Test</h3>
                        </above-fold>
                        <below-fold>
                            <p>If no class is set, the content will be vertically centered before hover.</p>
                        </below-fold>
                    </generic-tile>
                    <h3>Tile has class "bottom"</h3>
                    <generic-tile class="bottom" background-image="//lorempixel.com/400/400/animals">
                        <above-fold>
                            <h5 style="color: red">No Class Test</h3>
                        </above-fold>
                        <below-fold>
                            <p>If no class is set, the content will be vertically centered before hover.</p>
                        </below-fold>
                    </generic-tile>
                    <h3>Tile has class "top"</h3>
                    <generic-tile class="top" background-image="//lorempixel.com/400/400/animals">
                        <above-fold>
                            <h5 style="color: red">No Class Test</h3>
                        </above-fold>
                        <below-fold>
                            <p>If no class is set, the content will be vertically centered before hover.</p>
                        </below-fold>
                    </generic-tile>
                </div>
            </file>
            <file name="script.js">
                (function() {
                    angular.module('dataExample', ['components.tiles'])
                        .controller('exampleController', exampleController);

                    exampleController.$inject = ['$scope'];
                    function exampleController($scope) {
                        $scope.tileData = {
                            url: '#',
                            image: {
                                caption: 'Test Image',
                                url: '//lorempixel.com/400/400/Test Image',
                                height: 400,
                                width: 400,
                                crops: [
                                    {
                                        name: 'tile',
                                        height: 400,
                                        width: 400,
                                        url: '//lorempixel.com/400/400/Test Image'
                                    }
                                ]
                            },
                            name: 'Example Tile',
                            summary: '<p>This is an example tile. You can put a variety of content in here.</p>'
                        };
                    }
                })();
            </file>
        </example>
     */
    genericTile.$inject = ['$window', '$filter', '$timeout'];
    function genericTile($window, $filter, $timeout) {
        var directive = {
            scope: {
                backgroundImage: '@?'
            },
            transclude: {
                'aboveFold': 'aboveFold',
                'belowFold': 'belowFold'
            },
            templateUrl: '/angular/components/tiles/genericTile.html',
            replace: true,
            restrict: 'E', 
            link: link
        };
        return directive;
        function link(scope, element, attrs) {            
            if (scope.crop === undefined)
                scope.crop = 'tile';
            var title = element.find('.title');
            scope.titleHeight = 0;
            function sizeTitle() {
                var height = title.height();
                if (scope.titleHeight !== height) {
                    scope.$evalAsync(function () {
                        scope.titleHeight = height;
                        scope.flexStyle = {
                            flex: '0 1 ' + ((height + 30) / element.height() * 100) + '%'                            
                        };
                    });
                }
            }
            $timeout(function () {
                sizeTitle();
            }, 300);
            $($window).on('resize', sizeTitle);
            if (scope.backgroundImage) {
                var image = new Image();
                image.onload = function () {
                    scope.background = {
                        backgroundImage: 'url("' + scope.backgroundImage + '")'
                    }
                    scope.loaded = true;
                    scope.$evalAsync();
                }
                image.onerror = function () {
                    scope.$evalAsync(function () {
                        scope.loaded = true;
                    });
                }
                image.src = scope.backgroundImage;
            }
            else
                scope.loaded = true;
            var content = element.find('.vc');
            var isSmall = matchMedia('(max-width: 40em)');
            element.on('mouseenter', function () {
                if (!isSmall.matches) {
                    scope.$evalAsync(function () {
                        scope.offset = Math.max(0, (element.height() - content.height() - 30) / 2);
                    });
                }
            }).on('mouseleave', function () {
                if (!isSmall.matches) {
                    scope.$evalAsync(function () {
                        scope.offset = 0;
                    });
                }
            });
            scope.$on('$destroy', function () {
                element.off('mouseenter').off('mouseleave');
            });
        }
    }

    customTile.$inject = ['$window', '$filter', '$timeout'];
    function customTile($window, $filter, $timeout) {
        var directive = {
            scope: {
                data: '='
            },
            templateUrl: function (elem, attrs) {
                if (attrs.type === undefined || attrs.type == '') attrs.type = 'generic';

                return '/angular/components/tiles/' + attrs.type + 'Tile.html'
            },
            replace: true,
            restrict: 'E',
            link: link
        };
        return directive;
        function link(scope, element, attrs) {
        }
    }

    //accordionTilesController.$inject = ['$scope']
    //function accordionTilesController($scope) {
    //    var controller = this;
    //    controller.columns = 3;
    //    var sections = [];

    //    controller.getOffset = function (element) {
    //        return Math.round(controller.container[0].getBoundingClientRect().left - element[0].getBoundingClientRect().left);
    //    }

    //    controller.activateTile = function (scope) {
    //        scope.active = !scope.active;
    //        if (controller.prevScope !== undefined && scope.$id !== controller.prevScope.$id)
    //            controller.prevScope.active = false;
    //        controller.prevScope = scope;
    //    }

    //    controller.registerSection = function (sectionScope) {
    //        sections.push(sectionScope);
    //        if (sections.length === 1 && controller.autoOpen === true)
    //            controller.activateTile(sectionScope);
    //    }
    //}

    //accordionTiles.$inject = ['$window', '$timeout'];
    //function accordionTiles($window, $timeout) {
    //    var directive = {
    //        restrict: 'A',
    //        controller: 'accordionTilesController',
    //        link: link
    //    };
    //    return directive;
    //    function link(scope, element, attrs, controller) {
    //        controller.autoOpen = attrs.autoOpen === '' || attrs.autoOpen === 'true';
    //        controller.container = element;
    //        if (!$window.Foundation || $window.Foundation.MediaQuery) {
    //            console.log('Foundation for sites is not installed.');
    //        }
    //        else {
    //            var win = angular.element($window).on('changed.zf.mediaquery', function (event, newSize, oldSize) {
    //                console.log(newSize);
    //            }).on('resize.accordion', function () {

    //            });
    //            scope.$on('$destroy', function () {
    //                win.off('resize.accordion');
    //            });
    //        }
    //    }
    //}

    ///**
    // * @ngdoc directive
    // * @module components.tiles
    // * @name components.tiles:accordionTile
    // * @scope
    // * @restrict E
    // * @description
    // * Tile that reveals detailed information immediately beneath it when clicked. Must be nested beneath a tag with the "accordion-tiles" attribute. There are three tags for adding content in this widget.
    // * - **trigger:** This controls the content in the button that reveals content when clicked.
    // * - **full:** This is the content that is used when the accordion functionality is disabled. This is only used when a breakpoint attribute is set, so it doesn't need to be included if that attribute is not defined.
    // * - **summary:** This is the content that appears when the accordion trigger is clicked.
    // * @example
    //    <example module="dataExample">
    //        <file name="index.html">
    //            <div ng-controller="exampleController">
    //                <ul accordion-tiles class="large-12 small-up-2 medium-up-3 large-up-4 grid-block">
    //                    <li ng-repeat="tile in tiles">
    //                        <accordion-tile>
    //                            <trigger>
    //                                <div style="background-color: red; padding: 1em;">{{tile.name}}</div>
    //                            </trigger>
    //                            <summary>
    //                                <div ng-bind-html="tile.summary|trustAsMarkup"></div>
    //                            </summary>
    //                        </accordion-tile>
    //                    </li>
    //                </ul>
    //            </div>
    //        </file>
    //        <file name="script.js">
    //            (function() {
    //                angular.module('dataExample', ['components.tiles'])
    //                    .controller('exampleController', exampleController);

    //                exampleController.$inject = ['$scope'];
    //                function exampleController($scope) {
    //                    $scope.tiles = [];
    //                    for (var i=0; i<12; i++) {
    //                        $scope.tiles.push({
    //                            name: 'Tile ' + i,
    //                            summary: '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam eu pharetra ex. Curabitur eu nunc id dolor laoreet consectetur nec ornare elit. Vivamus elementum turpis ac mi vehicula fermentum. Morbi eget neque justo. Cras id elit condimentum felis vehicula suscipit. Maecenas sagittis pulvinar ante, eu cursus justo placerat ac. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam lacus leo, tristique eu nunc a, placerat placerat tortor. Fusce eget consectetur ante. Suspendisse lobortis dui libero. In ac libero vel eros ultricies auctor nec in felis. Vestibulum sed odio orci.</p><p>Curabitur pellentesque lobortis dui, et luctus ex convallis id. Cras scelerisque augue at imperdiet placerat. In diam velit, congue at diam ut, iaculis feugiat turpis. Donec id elit id elit vestibulum semper. Curabitur quis neque quis ipsum ultricies tincidunt vitae varius lectus. Proin at erat vestibulum, hendrerit urna ac, cursus mi. Cras pulvinar at felis vitae gravida. Nunc egestas rhoncus felis, vel vestibulum nisl condimentum quis. Vestibulum quis iaculis elit.</p>'
    //                        });
    //                    }
    //                }
    //            })();
    //        </file>
    //    </example>
    // */
    //accordionTile.$inject = ['$timeout', '$window', 'FoundationMQ'];
    //function accordionTile($timeout, $window, foundationMQ) {
    //    var directive = {
    //        replace: true,
    //        templateUrl: '/angular/components/tiles/accordionTile.html',
    //        transclude: {
    //            'trigger': 'trigger',
    //            'full': '?full',
    //            'summary': 'summary'
    //        },
    //        require: '^accordionTiles',
    //        link: link
    //    };
    //    return directive;
    //    function link(scope, element, attrs, controller) {
    //        controller.registerSection(scope);
    //        scope.open = function () {
    //            controller.activateTile(scope);
    //        }
    //        var contentHeight;
    //        var content;

    //        if (attrs.breakpoint) {
    //            var breakpointCheck = matchMedia(foundationMQ.getMediaQueries()[attrs.breakpoint]);

    //            function _checkDisplay(mq) {
    //                $timeout(function () {
    //                    scope.disabled = mq.matches;
    //                });
    //            }

    //            if (breakpointCheck) {
    //                breakpointCheck.addListener(_checkDisplay);
    //                _checkDisplay(breakpointCheck)
    //            }

    //        }

    //        function _updatePosition() {
    //            $timeout(function () {
    //                content = element.find('.content');
    //                scope.position = {
    //                    width: controller.container.width(),
    //                    left: controller.getOffset(element)
    //                }
    //                $timeout(function () {
    //                    contentHeight = content.find('>div').innerHeight();
    //                    scope.position.height = contentHeight;
    //                })
    //            });
    //        }
    //        _updatePosition();
    //        var win = angular.element($window).on('resize.accordion' + scope.$id, _updatePosition);
    //        scope.$on('$destroy', function () {
    //            win.off('resize.accordion' + scope.$id);
    //        })
    //    }
    //}

    /**
     * @ngdoc directive
     * @module components.tiles
     * @name components.tiles:windowTile
     * @scope
     * @restrict E
     * @description
     * Tile that animates in like a curtain opening. There is an issue with the animation for this widget in ngdocs, so it has been temporarily disabled.
     * @example
        <example module="dataExample">
            <file name="index.html">
                <div ng-controller="exampleController">
                    <h3>No Class</h3>
                    <window-tile>
                        <img src="//placehold.it/400?text=Placeholder" />
                        <h3>This is a test.</h3>
                        <p>of a window like tile</p>
                    </window-tile>
                </div>
            </file>
            <file name="script.js">
                (function() {
                    angular.module('dataExample', ['components.tiles'])
                        .controller('exampleController', exampleController);

                    exampleController.$inject = ['$scope'];
                    function exampleController($scope) {
                    }
                })();
            </file>
        </example>
     */
    function windowTile() {
        var directive = {
            scope: true,
            transclude: true,
            templateUrl: '/angular/components/tiles/windowTile.html',
            replace: true,
            restrict: 'E',
            link: link
        }
        return directive;
        function link(scope, element, attrs, controller, transclude) {
            var imageCount;
            scope.loading = true;
            transclude(function (clone) {
                if (clone.length) {
                    element.find('.content').append(clone);
                    imageCount = clone.filter('img').length + clone.find('img').length;
                }
            });
            if (imageCount) {
                scope.$on('imageLoaded', function (event, data) {
                    imageCount--;
                    if (imageCount === 0) {
                        scope.loading = false;
                    }
                });
            }
            else
                scope.loading = false;
        }
    }

    windowAnimation.$inject = [];
    function windowAnimation() {
        return {
            removeClass: function (element, className, doneFn) {
                if (className === 'loading') {
                    var tl = new TimelineLite();
                    var lights = element.find('.lights');
                    var light = lights.find('.light');
                    var curtain = element.find('.curtain');
                    tl.add(TweenLite.to(light, .01, {
                        opacity: .8,
                        css: {
                            backgroundColor: '#FABB4A'
                        },
                        delay: 1
                    }));
                    tl.add(TweenLite.to(curtain.find('.fa-spin'), .4, {
                        opacity: 0
                    }));
                    tl.add(TweenLite.to(curtain, .8, {
                        bottom: '100%',
                        delay: .5
                    }));
                    tl.add(TweenLite.to(light, .3, {
                        opacity: .9,
                        delay: -.7
                    }));
                    tl.add(TweenLite.to(light, .3, {
                        opacity: 0,
                        delay: -.3
                    }));
                    tl.add(TweenLite.to(lights, .001, {
                        display: 'none'
                    }));
                }
            }
        }
    }

    /**
     * @ngdoc directive
     * @module components.tiles
     * @name components.tiles:windowTile
     * @scope
     * @restrict E
     * @description
     * Tile that animates in like a curtain opening. There is an issue with the animation for this widget in ngdocs, so it has been temporarily disabled.
     * @example
        <example module="dataExample">
            <file name="index.html">
                <div ng-controller="exampleController">
                    <h3>No Class</h3>
                    <window-tile>
                        <img src="//placehold.it/400?text=Placeholder" />
                        <h3>This is a test.</h3>
                        <p>of a window like tile</p>
                    </window-tile>
                </div>
            </file>
            <file name="script.js">
                (function() {
                    angular.module('dataExample', ['components.tiles'])
                        .controller('exampleController', exampleController);

                    exampleController.$inject = ['$scope'];
                    function exampleController($scope) {
                    }
                })();
            </file>
        </example>
     */
    assemblyTileController.$inject = ['$transclude', '$element', '$compile', '$scope'];
    function assemblyTileController($transclude, $element, $compile, $scope) {
        var ctrl = this;
        ctrl.$onInit = function () {
            ctrl.$content = angular.element('<div class="background"><div class="content"><span class="plus fa fa-plus"></span></div></div>');
            ctrl.$content.find('.content').append($element.html());
        }
        ctrl.$postLink = function () {
            $element.html(ctrl.$content);
            $compile($element.contents())($scope.$parent);
            var tl = new TimelineLite({ paused: true});
            var background = $element.find('.background');
            var content = $element.find('.content');
            var plus = $element.find('.plus');
            tl.add(TweenLite.to(background, .4, {
                right: 0
            }));
            tl.add(TweenLite.to(content, .6, {
                opacity: 1,
                rotationX: 0
            }));
            tl.add(TweenLite.to(plus, .6, {
                rotationZ: 270,
                right: '8px',
                opacity: 1
            }));
            ctrl.$timeline = tl;
            $element.on('mouseenter.assemblyTile', function () {
                ctrl.$timeline.play();
            });
            $element.on('mouseleave.assemblyTile', function () {
                ctrl.$timeline.reverse();
            })
        }
    }
})();